<template>
	<section class="sign_up" :class="[theme, layout_choice]">
		<div class="container">
			<div class="inner">
				<slot></slot>

				<div class="content">
					<h2 v-if="title" v-html="title" :class="{ 'has-text': text }"></h2>
					<div class="sign_up__inner" v-if="text" v-html="text"></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		section_id: {},
		top_border: {},
		text: {},
		primary_cta: {},
		title: {},
		theme: {},
		layout_choice: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		let textIcons = document.querySelectorAll('.text_icon');

		textIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.sign_up {
	padding: 64px 0;

	.container {
		.inner {
			background: var(--fpe-mid-grey);
			grid-column: 1 / span 12;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			gap: 24px;
			padding: 48px 24px;
			border-radius: 16px;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				grid-template-columns: repeat(4, 1fr);
				padding: 24px;
			}

			.content {
				grid-column: 7 / span 6;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					order: 0;
				}

				h2 {
					color: var(--fpe-blue);
					margin-top: 0;
					margin-bottom: 0;
					font-family: var(--primary-font-family-heading);

					&.has-text {
						margin-bottom: 24px;
					}
				}

				.sign_up__inner {
					padding-right: 50px;
					color: var(--fpe-blue);
					font: normal normal 300 14px/20px var(--primary-font-family);

					@media (max-width: $mobile-xl) {
						padding-right: 0;
					}

					&::v-deep {
						p {
							color: var(--fpe-blue);
							font: normal normal 300 14px/20px var(--primary-font-family);
						}
					}
				}

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					margin-bottom: 0;
				}
			}

			> span {
				display: flex !important;
				grid-column: span 6;
				justify-content: flex-start;
				align-items: center;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					order: 1;
				}

				> .gform_wrapper {
					width: 100% !important;
				}

				@media (max-width: $mobile-xl) {
					grid-column: span 4;

					> .gform_wrapper {
						width: 100% !important;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SignUp.vue